export default "__VITE_ASSET__DoV_dnoz__"